import styles from "./styles.module.scss"
import PersonIcon from "~icons/eva/person-outline"
import FileTextIcon from "~icons/eva/file-text-outline"
import PricetagsIcon from "~icons/eva/pricetags-outline"
import CreditCardIcon from "~icons/eva/credit-card-outline"
import Link2Icon from "~icons/eva/link-2-outline"
import classNames from "classnames"
import CruiseIcon from "../../../../../../assets/icons/CruiseIcon"

type IconName = "person" | "fileText" | "cruiseShip" | "pricetags" | "creditCard" | "link"

const iconComponents: Record<IconName, JSX.Element> = {
  person: <PersonIcon />,
  fileText: <FileTextIcon />,
  cruiseShip: <CruiseIcon />,
  pricetags: <PricetagsIcon />,
  creditCard: <CreditCardIcon />,
  link: <Link2Icon />,
}

export const SidebarButton = ({
  iconName,
  label,
  onClick,
  isActive,
}: {
  iconName: IconName
  label: string
  isActive: boolean
  onClick: () => void
}) => {
  const Icon = iconComponents[iconName]

  return (
    <button
      className={classNames(styles.sidebarButton, isActive && styles.sidebarButtonActive)}
      onClick={onClick}
    >
      {Icon}
      <p>{label}</p>
    </button>
  )
}
